/**
 * The one width under which the interface is a phone: one column, the rail a
 * drawer, a tab bar below. The layout reads it in JS (`frame.tsx`) and the
 * stylesheet reads it as `phone:` — a root attribute set from the same
 * number — so no band of widths is a phone to one and a desktop to the other.
 */
export const PHONE_MAX = 760;

export const isPhoneWidth = (width: number): boolean => width < PHONE_MAX;

/** Keep `<html data-phone>` true exactly while the window is a phone. */
export function watchPhone(): void {
  const set = () => document.documentElement.toggleAttribute('data-phone', isPhoneWidth(window.innerWidth));
  set();
  window.addEventListener('resize', set);
}
